/***
*
*   DASHBOARD
*   Overview of your application usage with metrics, alerts, and activity
*
**********/

import { useState } from 'react';
import {
  Grid,
  Stat,
  Animate,
  useNavigate,
  useDashboardMetrics,
  useDashboardAlerts,
  usePlans,
  StorageUsage,
  PlanDistribution,
  RecentActivity,
  AlertsPanel
} from 'components/lib';
import Style from 'components/dashboard/dashboard.tailwind.js';

export function Dashboard(props) {
  const navigate = useNavigate();

  // Filter state
  const [filters, setFilters] = useState({
    plan: '',
    status: ''
  });

  // Fetch data with filters
  const metrics = useDashboardMetrics(filters);
  const plans = usePlans();
  const alerts = useDashboardAlerts({ limit: 10 });

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const handleViewOrg = (orgId) => {
    navigate(`/organizations/${orgId}`);
  };

  const handleSeeMoreAlerts = () => {
    navigate('/alerts');
  };

  // Destructure with correct API response structure
  const data = metrics.data || {};
  const {
    organizations = {},
    users = {},
    storage = {},
    plan_distribution = [],
    recent_activity = [],
    trial_stats = {}
  } = data;

  console.log('Dashboard metrics data:', plans);
  return (
    <Animate type='pop'>
      {/* Filters */}
      <div className={Style.filterContainer}>
        <select
          className={Style.filterSelect}
          value={filters.plan}
          onChange={(e) => handleFilterChange('plan', e.target.value)}
        >
          <option value="">All Plans</option>
          {plans?.data?.list.map(plan => (
            <option key={plan.value} value={plan.value}>{plan.label}</option>
          ))}
        </select>

        <select
          className={Style.filterSelect}
          value={filters.status}
          onChange={(e) => handleFilterChange('status', e.target.value)}
        >
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {/* Top Stats Cards */}
      <Grid cols='4'>
        <Stat
          loading={metrics.loading}
          value={organizations.total || 0}
          label='Total Organizations'
          icon='briefcase'
        />
        <Stat
          loading={metrics.loading}
          value={users.total || 0}
          label='Total Users'
          icon='users'
        />
        <Stat
          loading={metrics.loading}
          value={users.owners || 0}
          label='Total Owners'
          icon='user-check'
        />
        <Stat
          loading={metrics.loading}
          value={trial_stats.active_trials || 0}
          label='Active Trials'
          icon='clock'
        />
      </Grid>

      {/* Second Row: Storage & Plan Distribution */}
      <Grid cols='2'>
        <StorageUsage
          used={storage.used || 0}
          allocated={storage.allocated || 0}
          usagePercent={storage.usage_percent || 0}
          overQuotaCount={storage.over_quota_count || 0}
          loading={metrics.loading}
        />
        <PlanDistribution
          data={plan_distribution}
          loading={metrics.loading}
        />
      </Grid>

      {/* Third Row: Recent Activity & Alerts */}
      <Grid cols='2'>
        <RecentActivity
          data={recent_activity}
          loading={metrics.loading}
        />
        <AlertsPanel
          data={alerts.data || {}}
          loading={alerts.loading}
          onViewOrg={handleViewOrg}
          onSeeMore={handleSeeMoreAlerts}
          maxItems={6}
        />
      </Grid>
    </Animate>
  );
}